export const type = 'ECD/delete';

export default fields => ({
  type,
  error: false,
  payload: fields,
});
